import FocusLock from "./FocusLock.mjs";
export * from "./FocusLock.mjs";
var lib_default = FocusLock;
export {
  lib_default as default
};
